import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { PROCESOS_ELECTORALES, CONFIGURACION_SISTEMA } from 'constants/nombresCatalogos';
import * as fieldMsgs from 'constants/formFieldsMessages';
import { ambitos } from 'constants/ambitos';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { Form, Row, Select, DatePicker, Col } from 'antd';
import { Button } from 'components';
import { DATE_FORMAT_FILTER_COLUMN, DATE_FORMAT_BD } from 'utils/date';
import './BuscadorBitacoraNotificacion.scss';

export const BuscadorBitacoraNotificacion = ({ onSearch }) => {
  const [searchForm] = Form.useForm();
  const procesosElectorales = useSelector(selectCatalogByName(PROCESOS_ELECTORALES));
  const configuracionSistema = useSelector(selectCatalogByName(CONFIGURACION_SISTEMA));
  const dateFormat = 'YYYYMMDD';
  const fechaHoy = new Date().toISOString().slice(0, 10);
  const { RangePicker } = DatePicker;

  const fechaIniciOper =
    configuracionSistema.find((config) => config.parametro === 'FECHA_INICIO_OPERACIONES')?.valor ||
    null;

  const validateFechas = (_, dateValues) => {
    if (
      dateValues &&
      dateValues.length === 2 &&
      dateValues[0] !== undefined &&
      dateValues[0] !== null &&
      dateValues[0] !== '' &&
      dateValues[1] !== undefined &&
      dateValues[1] !== null &&
      dateValues[1] !== ''
    ) {
      if (dateValues[1] && dateValues[1].isBefore(dateValues[0])) {
        return Promise.reject(Error('La fecha inicial no puede ser posterior a la fecha final.'));
      }
    }
    return Promise.resolve();
  };

  const handleSearchByFilters = async () => {
    try {
      const params = await searchForm.validateFields();

      // Formatear fechas si están definidas
      if (params.fechas && params.fechas.length === 2) {
        params.fechaInicio = params.fechas[0].format(DATE_FORMAT_BD);
        params.fechaFinal = params.fechas[1].format(DATE_FORMAT_BD);
        delete params.fechas;
      }

      // Realizar la búsqueda con los parámetros
      onSearch(params);
    } catch (error) {
      /* empty */
      // console.error('Error al validar y procesar los filtros: ', error);
    }
  };

  const handleClearFilters = () => {
    // Se resetea filtro
    searchForm.resetFields();
    onSearch({});
  };

  return (
    <div className="buscador-bitacora-notificacion">
      <Form form={searchForm} layout="horizontal">
        <Row gutter={24}>
          <Col xs={6}>
            <span className="buscador-bitacora-notificacion-etiqueta">
              <span style={{ color: 'red' }}>&#42;</span>Proceso Electoral:
            </span>
            <Form.Item
              name="idProcesoElectoral"
              className="buscador-bitacora-notificacion-etiqueta"
              rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
              <Select
                placeholder="Selecciona"
                allowClear
                options={procesosElectorales}
                fieldNames={{
                  value: 'idProcesoElectoral',
                  label: 'descripcion'
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={5}>
            <span className="buscador-bitacora-notificacion-etiqueta">
              <span style={{ color: 'red' }}>&#42;</span>Ámbito:
            </span>
            <Form.Item
              name="idAmbito"
              className="buscador-bitacora-notificacion-etiqueta"
              rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
              <Select
                placeholder="Selecciona"
                allowClear
                options={ambitos}
                fieldNames={{
                  value: 'value',
                  label: 'label'
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={8}>
            <span className="buscador-bitacora-notificacion-etiqueta"> Fechas: </span>
            <Form.Item
              name="fechas"
              className="buscador-bitacora-notificacion-etiqueta"
              rules={[
                {
                  validator: validateFechas
                }
              ]}>
              <RangePicker
                format={DATE_FORMAT_FILTER_COLUMN}
                minDate={dayjs(fechaIniciOper, dateFormat)}
                maxDate={dayjs(fechaHoy, dateFormat)}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <br />
      <div className="buscador-bitacora-notificacion-acciones">
        <Button text="Limpiar" onClick={handleClearFilters} />
        <span style={{ width: '1em' }} />
        <Button text="Buscar" type="primary" onClick={handleSearchByFilters} />
      </div>
    </div>
  );
};

BuscadorBitacoraNotificacion.propTypes = {
  onSearch: PropTypes.func.isRequired
};
